import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import defaultimage from "../../assets/default-image.png";
import { validateProfileComplete } from '../../utils/profileValidation';

const WelcomeBanner = () => {
  const navigate = useNavigate();
  const Token = localStorage.getItem('AccessToken');
  const UserID = localStorage.getItem('UserID');
  const loginType = localStorage.getItem("AccountType");
  const [socialMediaAccounts, setSocialMediaAccounts] = useState([]);
  
  const userProfile = (() => {
    const storedProfile = localStorage.getItem('userProfile');
    if (storedProfile) {
      try {
        return JSON.parse(storedProfile);
      } catch (e) {
        return null;
      }
    }
    return null;
  })();

  // Fetch social media accounts
  useEffect(() => {
    const fetchSocialMediaAccounts = async () => {
      if (!UserID) {
        console.log('⚠️ WelcomeBanner: No UserID found');
        return;
      }
      
      try {
        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
        // Try both possible paths
        const url = `${API_BASE_URL}/api/GetAllSocialMediaAccounts/${UserID}`;
        console.log('📡 WelcomeBanner: Fetching social media accounts from:', url);
        
        const response = await fetch(url);
        console.log('📡 WelcomeBanner: Response status:', response.status);
        
        if (response.ok) {
          const accounts = await response.json();
          console.log('📡 WelcomeBanner: Fetched accounts:', accounts);
          console.log('📡 WelcomeBanner: Number of accounts:', accounts?.length || 0);
          setSocialMediaAccounts(accounts || []);
        } else {
          const errorText = await response.text();
          console.error('❌ WelcomeBanner: Error response:', errorText);
          // Try alternative path
          try {
            const altUrl = `${API_BASE_URL}/api/login/GetAllSocialMediaAccounts/${UserID}`;
            console.log('📡 WelcomeBanner: Trying alternative path:', altUrl);
            const altResponse = await fetch(altUrl);
            if (altResponse.ok) {
              const accounts = await altResponse.json();
              console.log('📡 WelcomeBanner: Fetched accounts from alternative path:', accounts);
              setSocialMediaAccounts(accounts || []);
            }
          } catch (altError) {
            console.error('❌ WelcomeBanner: Alternative path also failed:', altError);
          }
        }
      } catch (error) {
        console.error('❌ WelcomeBanner: Error fetching social media accounts:', error);
      }
    };

    fetchSocialMediaAccounts();
  }, [UserID]);

  const handleLinkedInLogin = () => {
    if (!UserID) {
      console.error('UserID not found');
      return;
    }
    // Use backend API endpoint like home.js does - this handles the LinkedIn OAuth configuration properly
    const linkedinAuthorizeUrl = `${process.env.REACT_APP_API_BASE_URL}/api/linkedin/authorize?UserID=${UserID}&loginType=${loginType}&scopes=openid profile email w_member_social`;
    window.location.href = linkedinAuthorizeUrl;
  };

  // Use test app ID only for local/development environments
  const isLocal = !process.env.REACT_APP_API_BASE_URL || 
                  process.env.REACT_APP_API_BASE_URL.includes('localhost') ||
                  window.location.hostname === 'localhost' ||
                  window.location.hostname === '127.0.0.1';
  const FACEBOOK_APP_ID = isLocal ? "1235662261837836" : "1177845164523132";
  const redirectToFacebook = () => {
    if (!UserID) {
      console.error('UserID not found');
      return;
    }
    // Redirect URI should point to backend callback endpoint
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
    const redirectUri = encodeURIComponent(`${API_BASE_URL}/api/auth/facebook/callback`);
  
    // Facebook Pages scopes (for posting to Facebook Pages)
    const scopes = [
      'email',
      'public_profile',
      'pages_show_list',           // List user's Facebook Pages - required to get page tokens
      'pages_read_engagement',     // Read page insights/engagement (REQUIRED for posting)
      //'pages_manage_metadata',     // Manage page metadata
      'pages_manage_posts',        // REQUIRED: Post to Facebook Pages (needs App Review for production)
      //'business_management',       // Access Business Accounts to get pages owned by businesses
      'instagram_basic',           // Access Instagram Basic Display API (required for Instagram detection)
      'instagram_content_publish',   // Publish content to Instagram (required for Instagram posting)
      'pages_read_user_content',   // Publish content to Instagram (required for Instagram posting)
      'pages_manage_engagement'
    ].join(',');
  
    // Include UserID and LoginType in state parameter (similar to LinkedIn pattern)
    const state = encodeURIComponent(`${UserID || ''}:Page`);
  
    // Add auth_type=reauthorize to force Facebook to show permission dialog again
    // This ensures users grant new permissions even if they've already authorized the app
    window.location.href = `https://www.facebook.com/v18.0/dialog/oauth?
      client_id=${FACEBOOK_APP_ID}
      &redirect_uri=${redirectUri}
      &scope=${scopes}
      &state=${state}
      &auth_type=reauthorize
    `.replace(/\s+/g, '');
  };

  return (
    <div className="welcome-banner-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: 0, position: 'relative' }}>
      {/* Desktop Layout */}
      <div className="d-flex align-items-center welcome-banner-left">
        <div className="me-3">
          <div
            className="rounded-circle"
            style={{
              width: '48px',
              height: '48px',
              border: '2px solid rgba(255,255,255,0.3)',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255,255,255,0.1)'
            }}
          >
            <img
              src={userProfile && userProfile.length > 0 && userProfile[0]?.ProfileUrl ? userProfile[0].ProfileUrl : defaultimage}
              alt="Profile"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
              onError={(e) => {
                e.target.src = defaultimage;
              }}
            />
          </div>
        </div>
        <div>
          <h4 className="mb-0 fw-bold text-white" style={{
            fontSize: '1.1rem',
            letterSpacing: '-0.3px',
            lineHeight: '1.2'
          }}>
            Welcome, {userProfile && userProfile.length > 0 ?
              (userProfile[0]?.OrganizationName || userProfile[0]?.FullName) :
              'User'
            }
          </h4>
          {localStorage.getItem('IsActive') == "true" && (
          <div className="d-flex align-items-center mt-1">
            {localStorage.getItem('subscriptionEndDate') && localStorage.getItem('subscriptionEndDate') !== 'null' ? (
              <>
                <span className="badge bg-white me-2 px-2 py-1" style={{
                  fontSize: '10px',
                  fontWeight: '600',
                  color: '#2e3192',
                  borderRadius: '12px'
                }}>
                  ✨ Premium
                </span>
                <small className="text-white" style={{ fontSize: '11px', opacity: 0.9 }}>
                  Active subscription
                </small>
              </>
            ) : (
              <>
                <span className="badge bg-warning me-2 px-2 py-1" style={{
                  fontSize: '10px',
                  fontWeight: '600',
                  color: '#000',
                  borderRadius: '12px'
                }}>
                  Free Trial
                </span>
                <small className="text-white" style={{ fontSize: '11px', opacity: 0.9 }}>
                  Limited features
                </small>
              </>
            )}
          </div>)}
        </div>
      </div>
      <div className="d-flex gap-2 align-items-center welcome-banner-right">
        {localStorage.getItem('IsActive') == "true" && (<button
          className="btn btn-light"
          onClick={() => {
            // Check profile completion before navigating to Create Post Page
            if (!validateProfileComplete({ navigate })) {
              return; // Don't navigate if profile is incomplete
            }
            navigate('/create-post');
          }}
          title="Create Post"
          style={{
            borderRadius: '8px',
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#2e3192',
            border: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            fontSize: '16px',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-1px)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
          }}
        >
          <FaPlus />
        </button>)}
        
        {/* Display connected social media accounts with platform icons - Clickable for login */}
        {socialMediaAccounts.length > 0 && console.log('🎨 WelcomeBanner: Rendering', socialMediaAccounts.length, 'social media accounts:', socialMediaAccounts)}
        {socialMediaAccounts.map((account) => {
          let profileUrl = null;
          let platformIcon = null;
          let platformName = '';
          
          if (account.PlatformId === 1) {
            // LinkedIn
            profileUrl = account.LinkedInProfileUrl;
            platformIcon = <i className="fa fa-linkedin" style={{ fontSize: '12px', color: '#0077b5' }}></i>;
            platformName = 'LinkedIn';
          } else if (account.PlatformId === 3) {
            // Facebook
            profileUrl = account.FacebookProfileUrl;
            platformIcon = <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#1877f2' }}>f</span>;
            platformName = 'Facebook';
          } else if (account.PlatformId === 4) {
            // Instagram
            profileUrl = account.FacebookProfileUrl; // Instagram profile pic is stored in FacebookProfileUrl
            platformIcon = <i className="fa fa-instagram" style={{ fontSize: '12px', color: '#E4405F' }}></i>;
            platformName = 'Instagram';
          }
          
          if (!profileUrl) {
            console.log('⚠️ WelcomeBanner: No profile URL for account:', account);
            return null;
          }
          
          // Determine click handler based on platform
          const handleClick = () => {
            if (account.PlatformId === 1) {
              // LinkedIn
              handleLinkedInLogin();
            } else if (account.PlatformId === 3 || account.PlatformId === 4) {
              // Facebook or Instagram
              if (loginType === 'Page') {
                redirectToFacebook();
              }
            }
          };

          return (
            <div
              key={account.AccountId}
              title={`${platformName} - Click to login/reconnect`}
              onClick={handleClick}
              style={{
                position: 'relative',
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                overflow: 'hidden',
                border: '1px solid rgba(255,255,255,0.3)',
                backgroundColor: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <img
                src={profileUrl}
                alt={platformName}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              {/* Platform icon overlay */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '2px',
                  right: '2px',
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  backgroundColor: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '2px solid white',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                  zIndex: 10
                }}
              >
                {platformIcon}
              </div>
            </div>
          );
        })}
        
        {/* Show login buttons for platforms that are not yet connected */}
        {/* Facebook button - Show for Page account type if no Facebook account is connected */}
        {loginType === 'Page' && !socialMediaAccounts.some(acc => acc.PlatformId === 3) && (
          <button
            className="btn btn-outline-light"
            onClick={redirectToFacebook}
            title="Login with Facebook"
            style={{
              borderRadius: '8px',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid rgba(255,255,255,0.3)',
              backgroundColor: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(10px)',
              fontSize: '16px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.15)';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <i className="fa fa-facebook-f"></i>
          </button>
        )}
        {/* Instagram button - always show when Instagram is not connected, even for first-time users */}
        {loginType === 'Page' && !socialMediaAccounts.some(acc => acc.PlatformId === 4) && (
          <button
            className="btn btn-outline-light"
            onClick={redirectToFacebook}
            title="Login with Instagram (via Facebook)"
            style={{
              borderRadius: '8px',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid rgba(255,255,255,0.3)',
              backgroundColor: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(10px)',
              fontSize: '16px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.15)';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <i className="fa fa-instagram"></i>
          </button>
        )}
        {/* LinkedIn button - Show if not connected */}
        {!socialMediaAccounts.some(acc => acc.PlatformId === 1) && (
          <button
            className="btn btn-outline-light"
            onClick={handleLinkedInLogin}
            title={Token == null ? 'Login with LinkedIn' : 'Login with another LinkedIn account'}
            style={{
              borderRadius: '8px',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid rgba(255,255,255,0.3)',
              backgroundColor: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(10px)',
              fontSize: '16px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.15)';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <i className="fa fa-linkedin"></i>
          </button>
        )}
      </div>

      {/* Mobile Layout */}
      <div className="welcome-banner-mobile">
        <div className="d-flex align-items-center justify-content-between" style={{ width: '100%', position: 'relative' }}>
          {/* Profile and Name - Left side, moved closer to chevron */}
          <div className="d-flex align-items-center" style={{ flex: 1, minWidth: 0, gap: '10px' }}>
            <div style={{ flexShrink: 0 }}>
              <div
                className="rounded-circle"
                style={{
                  width: '56px',
                  height: '56px',
                  border: '2px solid rgba(255,255,255,0.3)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }}
              >
                <img
                  src={userProfile && userProfile.length > 0 && userProfile[0]?.ProfileUrl ? userProfile[0].ProfileUrl : defaultimage}
                  alt="Profile"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                  onError={(e) => {
                    e.target.src = defaultimage;
                  }}
                />
              </div>
            </div>
            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: 'calc(100vw - 200px)' }}>
              <h4 className="mb-0 fw-bold text-white welcome-name-mobile" style={{
                fontSize: '1rem',
                letterSpacing: '-0.3px',
                lineHeight: '1.3',
                marginBottom: '3px',
                wordBreak: 'break-word'
              }}>
                Welcome, {userProfile && userProfile.length > 0 ?
                  (userProfile[0]?.OrganizationName || userProfile[0]?.FullName) :
                  'User'
                }
              </h4>
              {localStorage.getItem('IsActive') == "true" && (
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                {localStorage.getItem('subscriptionEndDate') && localStorage.getItem('subscriptionEndDate') !== 'null' ? (
                  <>
                    <span className="badge bg-white px-2 py-1" style={{
                      fontSize: '10px',
                      fontWeight: '600',
                      color: '#2e3192',
                      borderRadius: '12px',
                      whiteSpace: 'nowrap',
                      lineHeight: '1.2'
                    }}>
                      ✨ Premium
                    </span>
                    <small className="text-white" style={{ fontSize: '10px', opacity: 0.9, whiteSpace: 'nowrap', lineHeight: '1.2' }}>
                      Active
                    </small>
                  </>
                ) : (
                  <>
                    <span className="badge bg-warning px-2 py-1" style={{
                      fontSize: '10px',
                      fontWeight: '600',
                      color: '#000',
                      borderRadius: '12px',
                      whiteSpace: 'nowrap',
                      lineHeight: '1.2'
                    }}>
                      Free Trial
                    </span>
                    <small className="text-white" style={{ fontSize: '10px', opacity: 0.9, whiteSpace: 'nowrap', lineHeight: '1.2' }}>
                      Limited
                    </small>
                  </>
                )}
              </div>)}
            </div>
          </div>
          {/* Action Buttons - Right side, horizontally arranged */}
          <div className="d-flex gap-2 align-items-center" style={{ flexShrink: 0, marginRight: '12px' }}>
            <button
              className="btn btn-light"
              onClick={() => {
                // Check profile completion before navigating to Create Post Page
                if (!validateProfileComplete({ navigate })) {
                  return; // Don't navigate if profile is incomplete
                }
                navigate('/create-post');
              }}
              title="Create Post"
              style={{
                borderRadius: '8px',
                width: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#2e3192',
                border: 'none',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                fontSize: '14px',
                transition: 'all 0.2s ease',
                padding: 0
              }}
            >
              <FaPlus />
            </button>
            
            {/* Display connected social media accounts with platform icons */}
            {socialMediaAccounts.map((account) => {
              let profileUrl = null;
              let platformIcon = null;
              let platformName = '';
              
              if (account.PlatformId === 1) {
                // LinkedIn
                profileUrl = account.LinkedInProfileUrl;
                platformIcon = <i className="fa fa-linkedin" style={{ fontSize: '10px', color: '#0077b5' }}></i>;
                platformName = 'LinkedIn';
              } else if (account.PlatformId === 3) {
                // Facebook
                profileUrl = account.FacebookProfileUrl;
                platformIcon = <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#1877f2' }}>f</span>;
                platformName = 'Facebook';
              } else if (account.PlatformId === 4) {
                // Instagram
                profileUrl = account.FacebookProfileUrl; // Instagram profile pic is stored in FacebookProfileUrl
                platformIcon = <i className="fa fa-instagram" style={{ fontSize: '10px', color: '#E4405F' }}></i>;
                platformName = 'Instagram';
              }
              
              if (!profileUrl) return null;
              
              return (
                <div
                  key={account.AccountId}
                  title={platformName}
                  style={{
                    position: 'relative',
                    width: '36px',
                    height: '36px',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    border: '1px solid rgba(255,255,255,0.3)',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    flexShrink: 0
                  }}
                >
                  <img
                    src={profileUrl}
                    alt={platformName}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                  {/* Platform icon overlay */}
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '2px',
                      right: '2px',
                      width: '16px',
                      height: '16px',
                      borderRadius: '50%',
                      backgroundColor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1.5px solid white',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                      zIndex: 10
                    }}
                  >
                    {platformIcon}
                  </div>
                </div>
              );
            })}
            
            {/* Facebook button - Only show for Page account type if not already connected */}
            {loginType === 'Page' && !socialMediaAccounts.some(acc => acc.PlatformId === 3) && (
              <button
                className="btn btn-outline-light"
                onClick={redirectToFacebook}
                title="Login with Facebook"
                style={{
                  borderRadius: '8px',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid rgba(255,255,255,0.3)',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  fontSize: '14px',
                  transition: 'all 0.2s ease',
                  padding: 0
                }}
              >
                <i className="fa fa-facebook-f"></i>
              </button>
            )}
            {/* LinkedIn button - Only show if not already connected */}
            {!socialMediaAccounts.some(acc => acc.PlatformId === 1) && (
              <button
                className="btn btn-outline-light"
                onClick={handleLinkedInLogin}
                title={Token == null ? 'Login with LinkedIn' : 'Login with another LinkedIn account'}
                style={{
                  borderRadius: '8px',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid rgba(255,255,255,0.3)',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  fontSize: '14px',
                  transition: 'all 0.2s ease',
                  padding: 0
                }}
              >
                <i className="fa fa-linkedin"></i>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;

